/// <amd-module name="Wit/MentionsAutocomplete/Utilities/Telemetry" />
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import * as Trace from "VSS/Platform/Trace";

const AREA = "wit-mentions";

export function publishEvent(pageContext: IVssPageContext, featureName: string, properties: { [key: string]: string | number | boolean }): void {
    const service = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    service.publishEvent(AREA, featureName, { projectId: _getProjectId(pageContext), ...properties });
}

export function traceError(
    pageContext: IVssPageContext,
    featureName: string,
    message: string,
    properties?: { [key: string]: string | number | boolean }
): void {
    Trace.traceError(pageContext, AREA, featureName, message, properties);
}

function _getProjectId(pageContext: IVssPageContext): string {
    const tfsPageService = pageContext.getService<ITfsPageService>("ITfsPageService");
    const tfsPageData = tfsPageService.getData();
    return tfsPageData!.project!.id;
}
